import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';
import './theme.css';


/* Force KONE light theme */
if (localStorage.getItem('theme') !== 'light') {localStorage.setItem('theme', 'light');}
ReactDOM.createRoot(document.getElementById('root')!).render(App.createRoot());
